import type { FeedbackPayload, FeedbackResponse } from "../types";
import { api } from "./core";

export const feedbackApi = {
  submitFeedback: (payload: FeedbackPayload) =>
    api<FeedbackResponse>("/feedback", { method: "POST", body: JSON.stringify(payload) }),
};
